'use client';
import { InternalLink } from '../../../../../components/Clickables/InternalLink/InternalLink';
import { useAnalytics } from '../../../../../contexts/AnalyticsContext/AnalyticsContext';
import { trackEvent } from '../../../../../helpers/analytics/trackEvent';

export interface HomePageFeatureSectionLinkProps {
  linkText: string;
  linkRoute: string;
  eventName?: string;
}

export const HomePageFeatureSectionLink = ({
  linkRoute,
  linkText,
  eventName = '',
}: HomePageFeatureSectionLinkProps) => {
  const { currentPage } = useAnalytics();

  const handleLinkClick = async ({ featureName }: { featureName: string }): Promise<void> => {
    void trackEvent({
      name: 'mykiss_cta_button_clicked',
      properties: {
        source: featureName,
        type: 'read-more',
        page: currentPage,
      },
    });
  };

  return (
    <InternalLink
      onClick={async () => handleLinkClick({ featureName: eventName })}
      to={linkRoute}
      variant="textPrimaryDarkBg"
    >
      {linkText}
    </InternalLink>
  );
};
